var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9D",
    d: "M27.037 2.799c0 1.536-1.246 2.78-2.782 2.779-1.536-.001-2.78-1.247-2.779-2.783.001-1.536 1.246-2.78 2.783-2.78 1.536.002 2.78 1.248 2.778 2.784M5.563 13.874l.008-11.09C5.57 1.248 4.327.002 2.79 0 1.255 0 .01 1.243.008 2.78L0 13.902c0 .457.11.92.346 1.349.742 1.346 2.433 1.834 3.778 1.093.93-.512 1.45-1.478 1.44-2.47",
    transform: "translate(.083 .297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M18.39 13.866l.008-11.073C18.4 1.256 17.154.01 15.618.01c-1.535-.001-2.781 1.244-2.782 2.78l-.009 11.127h.001c0 .455.11.917.346 1.343.741 1.346 2.434 1.835 3.778 1.095.934-.516 1.456-1.49 1.438-2.488M27.03 13.925c0 1.536-1.247 2.78-2.783 2.78-1.536-.002-2.78-1.248-2.78-2.784.001-1.537 1.248-2.78 2.784-2.779 1.536.001 2.78 1.246 2.78 2.783M11.593 4.208c.248-.416.39-.9.392-1.42 0-1.536-1.244-2.782-2.78-2.783C8.188.004 7.298.55 6.813 1.365L.38 12.504c-.476.818-.524 1.857-.034 2.746.742 1.346 2.434 1.834 3.779 1.092.467-.257.83-.629 1.075-1.062l6.393-11.073z",
    transform: "translate(.083 .297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9D",
    d: "M18.007 4.213c.248-.416.39-.901.392-1.421 0-1.536-1.245-2.782-2.78-2.783-1.017 0-1.907.545-2.392 1.36L6.793 12.51c-.476.817-.524 1.857-.034 2.746.741 1.344 2.434 1.834 3.779 1.093.467-.258.831-.63 1.075-1.063l6.393-11.073z",
    transform: "translate(.083 .297)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.dd4dd44728f4efa7f99f23c2f0281b2d.svg";
export { ForwardRef as ReactComponent };